import { cn } from '@/utils/utils_client';
import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';
import * as React from 'react';
import { forwardRef } from 'react';

interface Props extends React.ComponentPropsWithoutRef<typeof DropdownMenuPrimitive.Separator> {
  className?: string;
  label: string;
}

export const UI_PRIMITIVE__dropdown_menu_separator_labeled = forwardRef<React.ElementRef<typeof DropdownMenuPrimitive.Separator>, Props>(
  ({ label, className, ...props }, ref) => (
    <div {...props} ref={ref} className={cn('w-full bg-bar cursor-default rounded-sm ', className)}>
      {label}
    </div>
  ),
);

UI_PRIMITIVE__dropdown_menu_separator_labeled.displayName = DropdownMenuPrimitive.Separator.displayName;
